module.exports = __webpack_public_path__ + "1e68f18a42a89b1086fc4992acc49358.jpeg";


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/alt/scott.jpeg
// module id = 704
// module chunks = 0